/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { getAdminUrl, getAppHeaders, getBuyersUrl } from 'shared/http';
import { adminToken, buyerToken, externalAuth } from 'shared/settings/apiconfig';
import interfaceService from './interfaceService';

class AdminService {
    constructor() {
        this.service = interfaceService.getService();
    }

    logIn(data) {
        return this.service.post(getAdminUrl(adminToken), JSON.stringify(data), getAppHeaders(false));
    }

    getBuyerToken(token) {
        const headers = getAppHeaders(false);
        headers.headers['Authorization'] = `Bearer ${token}`;
        return this.service.get(getAdminUrl(buyerToken), headers);
    }

    getToken(data, token) {
        const headers = getAppHeaders(false);
        headers.headers['Authorization'] = `Bearer ${token}`;
        return this.service.post(getBuyersUrl(externalAuth), JSON.stringify(data), headers);
    }
}

export default new AdminService();
